"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useEffectAll;

var _react = require("react");

var _usePrevious = _interopRequireDefault(require("./usePrevious"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useEffectAll(fn, deps) {
  const prevDeps = (0, _usePrevious.default)(deps);
  const changeTarget = (0, _react.useRef)();
  (0, _react.useEffect)(() => {
    // nothing to compare to yet
    if (changeTarget.current === undefined) {
      changeTarget.current = prevDeps;
    } // we're mounting, so call the callback


    if (changeTarget.current === undefined) {
      return fn();
    } // make sure every dependency has changed


    if (changeTarget.current.every((dep, i) => dep !== deps[i])) {
      changeTarget.current = deps;
      return fn();
    }
  }, [fn, prevDeps, deps]);
}